import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { fromEvent, Subscription } from 'rxjs';
import { AppInstallDialogComponent } from '../../../@fury/shared/dialog/app-install-dialog/app-install-dialog.component';
import { LocalStorageService } from './local-storage.service';

@Injectable({providedIn: 'root'})

export class PwaInstallService implements OnDestroy {
  private deferredPrompt: any = null;
  private sub$: Subscription = new Subscription();
  public showInstallButton: boolean = false;

  constructor(
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
  ) {
  }

  init(): void {
    if (this.isIos()) {
      if (!this.isInStandaloneMode() && this.shouldShowIosPrompt()) {
        setTimeout((): void => this.showInstallDialog(), 2000);
      }
      return;
    }

    if (this.isInStandaloneMode()) {
      return;
    }

    this.sub$.add(
      fromEvent<Event>(window, 'beforeinstallprompt').subscribe((e: Event): void => {
        e.preventDefault();
        this.deferredPrompt = e;
        setTimeout((): void => this.showInstallDialog(), 2000);
      })
    );
  }

  public triggerInstallFromButton(): void {
    if (this.isIos()) {
      this.showInstallDialog();
    } else {
      this.triggerAndroidInstall().then((): void => {
      });
    }
  }

  async triggerAndroidInstall(): Promise<void> {
    if (!this.deferredPrompt) {
      return;
    }
    this.deferredPrompt.prompt();
    this.deferredPrompt = null;
  }

  public isIos(): boolean {
    return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
  }

  private isInStandaloneMode(): boolean {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      ('standalone' in navigator && (navigator as any).standalone === true)
    );
  }

  private shouldShowIosPrompt(): boolean {
    const stored: string = this.localStorageService.get('app-install-prompt');
    if (!stored) {
      return true;
    }

    if (stored === 'never') {
      return false;
    }

    const lastShown: number = new Date(stored).getTime();
    const now: number = Date.now();
    const diffDays: number = (now - lastShown) / (1000 * 60 * 60 * 24);
    return diffDays >= 14;
  }

  private markIosPromptShown(): void {
    this.localStorageService.set('app-install-prompt', new Date().toISOString());
  }

  private showInstallDialog(): void {
    const dialogRef: MatDialogRef<AppInstallDialogComponent> = this.dialog.open(AppInstallDialogComponent);
    this.markIosPromptShown();
    this.showInstallButton = true;

    dialogRef.afterClosed().subscribe((result: boolean): void => {
      if (!result) {
        this.localStorageService.set('app-install-prompt', 'never');
      }
      if (result && !this.isIos()) {
        this.triggerAndroidInstall().then((): void => {
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub$ !== null) {
      this.sub$.unsubscribe();
    }
  }
}
